import { render, staticRenderFns } from "./TeamAvatar.vue?vue&type=template&id=68c0f99c"
import script from "./TeamAvatar.vue?vue&type=script&lang=js"
export * from "./TeamAvatar.vue?vue&type=script&lang=js"
import style0 from "./TeamAvatar.vue?vue&type=style&index=0&id=68c0f99c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports